var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3428_11577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10H5V8C5 7.45 4.55 7 4 7C3.45 7 3 7.45 3 8V10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12H3V14C3 14.55 3.45 15 4 15C4.55 15 5 14.55 5 14V12H7C7.55 12 8 11.55 8 11C8 10.45 7.55 10 7 10ZM18 11C19.66 11 20.99 9.66 20.99 8C20.99 6.34 19.66 5 18 5C17.68 5 17.37 5.05 17.09 5.14C17.66 5.95 17.99 6.93 17.99 8C17.99 9.07 17.65 10.04 17.09 10.86C17.37 10.95 17.68 11 18 11ZM13 11C14.66 11 15.99 9.66 15.99 8C15.99 6.34 14.66 5 13 5C11.34 5 10 6.34 10 8C10 9.66 11.34 11 13 11ZM13 13C11 13 7 14 7 16V17C7 17.55 7.45 18 8 18H18C18.55 18 19 17.55 19 17V16C19 14 15 13 13 13ZM19.62 13.16C20.45 13.89 21 14.82 21 16V17.5C21 17.67 20.98 17.84 20.95 18H23.5C23.78 18 24 17.78 24 17.5V16C24 14.46 21.63 13.51 19.62 13.16Z",
    fill: "#5A6A85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3428_11577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomerIcon);
export default __webpack_public_path__ + "static/media/addCustomerIcon.cec13c7549540db6c74230596e0b0a63.svg";
export { ForwardRef as ReactComponent };